import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './AddSensor.css';
import DownloadSensorForm from './components/DownloadSensorForm';
import * as actions from '../../core/actions/actions';
import { reset } from 'redux-form';
import URLConstants from '../../core/constants/url.constants';
import { allBuildingsSelector } from '../../core/selectors/sensor.selector';
import IState from '../../core/models/IState';
import { formatMessage } from '../../translations/connectedIntlProvider';
import { toast } from 'react-toastify';

const DownloadSensor = (props: any) => {

  const dispatch = useDispatch();
  const { filePreparation }: any = useSelector((state: IState) => { return state.file });
  const buidlingList = useSelector(allBuildingsSelector);

  useEffect(() => {
    dispatch(actions.getUniqueBuilding());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const onSubmitForm = (values: any) => {
    let downloadURL = URLConstants.DownloadDecodedDataByDate;
    let donwloadObj = {
      StartDate: values.StartDate+" 00:00:00",
      EndDate: values.EndDate+" 23:59:59",
      Building: '',
      Floor: '',
      Room: '',
      Location: '',
      UserID: 0,
      CustomerID:'',
      ICCID:'',
      DateType: values.DateType,
      Prefix:''
    }
    let localStorageValue = localStorage.getItem('SensonLocation.Filter')!;
    var value = JSON.parse(localStorageValue);
    if (value) {
      donwloadObj.Building = value.Building;
      donwloadObj.Floor = value.Floor;
      donwloadObj.Room = value.Room;
      donwloadObj.Location = value.Location;
      donwloadObj.UserID = value.UserId;
      donwloadObj.CustomerID=value.CustomerId;
      donwloadObj.ICCID=value.ICCID;
    }
    donwloadObj.Prefix = values.Prefix;
    dispatch(actions.filePreparation(downloadURL, donwloadObj));
    // downloadCsvPost(downloadURL, donwloadObj);
    // onModalClosed();
  }

  useEffect(() => {
    if (filePreparation.success) {
      toast.success(formatMessage("File_Preparation_Started"));
      dispatch(actions.resetfilePreparationState());
      onModalClosed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filePreparation.success]);
  
  useEffect(() => {
    if (filePreparation.error != null) {
      toast.error(formatMessage(filePreparation.error));
      dispatch(actions.resetfilePreparationState());
      onModalClosed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filePreparation.error]);

  const onModalClosed = () => {
    dispatch(reset('DownloadSensorForm'));
    props.modalClosed();
  }

  return (
    <React.Fragment>
      <DownloadSensorForm
        id={props.id}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        buidlingList={buidlingList}
        isLoading={filePreparation.loading}
      />
    </React.Fragment>
  );
};

export default DownloadSensor;
